import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class Hba1cForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.hba1c ? $$('hba1c_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.hba1c ? "custom-error form-control" : "form-control"}
                               value={this.props.hba1c} placeholder={$$('hba1c_label')} name="hba1c"
                               onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getFormattedHBA1CUnit()}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.hba1c ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.hba1c ? $$(this.props.errors.hba1c) : $$('hba1c_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

Hba1cForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    healthIssues: PropTypes.object,
    logbookEntries: PropTypes.array,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    onInputChange: PropTypes.func,
    selectedUser: PropTypes.object,
    errors: PropTypes.any,
    hba1c: PropTypes.any,
    settings: PropTypes.object,
    show: PropTypes.bool,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}